export default "__VITE_ASSET__A2INF$Y9__"